import { render, staticRenderFns } from "./ScopeOfWork.vue?vue&type=template&id=4bc22f98"
import script from "./ScopeOfWork.vue?vue&type=script&lang=js"
export * from "./ScopeOfWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports